import { Body, Icon, useTheme } from "@merit/frontend-components";
import { FlatList, ScrollView, StyleSheet, View } from "react-native";
import { Header } from "@src/components";
import {
  brand,
  designName,
  deviceName,
  deviceType,
  deviceYearClass,
  isDevice,
  manufacturer,
  modelId,
  modelName,
  osBuildFingerprint,
  osBuildId,
  osInternalBuildId,
  osName,
  osVersion,
  platformApiLevel,
  productName,
  supportedCpuArchitectures,
  totalMemory,
} from "expo-device";
import { useNavigation } from "@src/hooks";
import type { TextStyle, ViewStyle } from "react-native";

export const DeviceInfo = () => {
  const { theme } = useTheme();
  const styles = StyleSheet.create<{
    readonly container: ViewStyle;
    readonly content: ViewStyle;
    readonly label: TextStyle;
    readonly value: TextStyle;
  }>({
    container: {
      backgroundColor: theme.colors.background.white,
      flex: 1,
    },
    content: {
      padding: theme.spacing.l,
      rowGap: theme.spacing.xxl,
    },
    label: {
      ...theme.fontSizes.l,
      fontWeight: theme.fontWeights.semiBold,
      marginBottom: theme.spacing.s,
    },
    value: {
      ...theme.fontSizes.m,
      paddingLeft: theme.spacing.s,
    },
  });

  const nav = useNavigation();

  return (
    <View style={styles.container}>
      <Header
        leftElement={<Icon name="chevronLeftMediumAction" />}
        leftOnPress={() => {
          nav.goBack();
        }}
        title="Device Info"
        titleBold
        titleLevel="3"
      />
      <ScrollView contentContainerStyle={styles.content}>
        <View>
          <FlatList
            data={Object.entries({
              brand,
              designName,
              deviceName,
              deviceType,
              deviceYearClass,
              isDevice,
              manufacturer,
              modelId,
              modelName,
              osBuildFingerprint,
              osBuildId,
              osInternalBuildId,
              osName,
              osVersion,
              platformApiLevel,
              productName,
              supportedCpuArchitectures,
              totalMemory,
            })}
            renderItem={({ item: [key, value] }) => (
              <View>
                <Body style={styles.label}>{key}</Body>
                <Body style={styles.value}>{JSON.stringify(value, null, 2)}</Body>
              </View>
            )}
            scrollEnabled={false}
          />
        </View>
      </ScrollView>
    </View>
  );
};
